import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WorkLocationsService } from '@app/modules/work-locations/services/work-locations.service';
import { GridState } from '@app/shared/services/grid-state/grid-state.model';
import { GridDataResult, SelectionEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-select-work-location-dialog',
  templateUrl: './select-work-location-dialog.component.html',
  styleUrls: ['./select-work-location-dialog.component.scss']
})
export class SelectWorkLocationDialogComponent implements OnInit {
  @Output() emitSelectedWorkLocations: EventEmitter<string[]> = new EventEmitter<string[]>();

  public gridDataResult: GridDataResult;
  public selectedItems: any[] = [];
  public columns: any[] = [
    { field: 'name', title: 'Name', dataType: "String" },
    { field: "streetAddress", title: "Street Address", tableId: "tfi_WlStreetAddress", dataType: "String" },
    { field: "city", title: "City", dataType: "String", tableId: "tfi_WlCity" },
    { field: "province", title: "Province", dataType: "String", tableId: "tfi_WlProvince" },
    { field: "zip", title: "Zip", dataType: "String", tableId: "tfi_WlZip" },
    { field: "region", subField: 'text', title: "Region", dataType: "String", tableId: "" },
    { field: "country", subField: 'name', title: "Country", dataType: "String", tableId: "tfi_WlCountry" },
    { field: "timezone", subField: 'text', title: "Timezone", dataType: "String", tableId: "" },
    { field: "stylingColours", subField: 'name', title: "styling Color", tableId: "" },
    { field: 'companyLogo', subField: 'id', title: 'Logo', type: 'logoImage', tableId: "" },
    { field: "startDate", title: "Start Date", type: "date", dataType: "Date", tableId: "" },
    { field: "endDate", title: "End Date", type: "date", dataType: "Date", tableId: "" },
  ];

  sortableColumns: any[] = [
    { field: "name", sortValue: "name" },
    { field: "streetAddress", sortValue: "streetAddress" },
    { field: "city", sortValue: "city" },
    { field: "province", sortValue: "province" },
    { field: "zip", sortValue: "zip" },
    { field: "region", sortValue: "region.text" },
    { field: "country", sortValue: "country.name" },
    { field: "timezone", sortValue: "timezone.text" },
    { field: "startDate", sortValue: "startDate" },
    { field: "endDate", sortValue: "endDate" },
    { field: "stylingColor", sortValue: "stylingColor" },
  ];

  public filterCategories: any[] = [].concat(this.columns);
  public sort: SortDescriptor[] = [];
  filterString: string;
  filterToggleDetails: {
    text: string,
    checked: boolean
  } = {
      text: 'FilterInactive',
      checked: true
    }
  isLoading: boolean;
  pageSize: number = 20;
  skip: number = 0;
  sortString: string;
  getWorkLocationsRequest: any;
  clearSelectedItems: boolean = false;
  selectedWorkLocations: any[] = [];

  public searchFilterString: string;
  public searchValue: string;
  getRequest: any;
  error: boolean;
  selectionSettings: { canSelectRows: boolean; selectableMode: any; selectRowBy: string; };

  constructor(
    private dialogRef: MatDialogRef<SelectWorkLocationDialogComponent>,
    private workLocationsService: WorkLocationsService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.selectedWorkLocations = data.nonSelectableItems || [];
    this.selectionSettings = {
      canSelectRows: true,
      selectableMode: data.selectableMode || 'single',
      selectRowBy: 'id'
    };
  }

  ngOnInit(): void {
    this.getWorkLocations();
  }

  get selectedWorkLocationsIds(): string[] {
    return this.selectedWorkLocations.map(location => location.id);
  }

  getWorkLocations(): void {
    this.isLoading = true;

    this.getRequest = this.workLocationsService.getWorkLocations(this.pageSize, this.skip, this.searchFilterString, this.sortString, this.filterToggleDetails.checked)
      .subscribe(
        {
          next: (v) => {
            this.gridDataResult = {
              data: v.data,
              total: v.total,
            }
          },
          error: (e) => {
            this.error = true;
            this.isLoading = false;
          },
          complete: () => this.isLoading = false
        }
      );
  }

  gridStateChange(gridState: GridState) {
    if (this.pageSize !== gridState.pageSize) {
      this.pageSize = gridState.pageSize;
    }
    if (this.skip !== gridState.skip) {
      this.skip = gridState.skip;
    }
    if (this.sortString !== gridState.sortString) {
      this.sortString = gridState.sortString;
    }
    if (this.filterString !== gridState.filter) {
      this.filterString = gridState.filter;
      this.skip = 0;
    }

    if (gridState.filterToggleDetails === null) {
      this.filterToggleDetails.checked = false;
      this.skip = 0;
    } else if (this.filterToggleDetails.checked !== gridState.filterToggleDetails.checked) {
      this.filterToggleDetails.checked = gridState.filterToggleDetails.checked;
      this.skip = 0;
    }

    if (this.searchValue !== gridState.searchValue) {
      let variants = [];
      this.searchFilterString = '';
      this.searchValue = gridState.searchValue;

      if (this.searchValue !== null) {
        variants = this.searchValue.split(' ').filter(value => value);
      }

      variants.map(variant => {
        if (variant) {
          if (this.searchFilterString.length > 2) {
            this.searchFilterString += ' OR ';
          }
          this.searchFilterString += `(Name like "${variant}")`;
        }
      });

      this.skip = 0;
    }

    this.getRequest.unsubscribe();
    this.getWorkLocations();
  }

  selectedRowsChanged(selectionEvent: SelectionEvent) {
    selectionEvent.selectedRows.forEach(row => {
      this.selectedWorkLocations.push(row.dataItem)
    });

    selectionEvent.deselectedRows.forEach(row => {
      this.selectedWorkLocations = this.selectedWorkLocations.filter(item => item.id !== row.dataItem.id)
    });
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.emitSelectedWorkLocations.emit(this.selectedWorkLocations);
    this.dialogRef.close();
  }

}
